import CategoryDropdown from './CategoryDropdown';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[680px] md:min-h-[780px] flex flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20pastel%20fashion%20flat%20lay%20with%20beauty%20products%20cosmetics%20and%20accessories%20on%20cream%20background%2C%20elegant%20minimal%20composition%20with%20soft%20natural%20lighting%2C%20scandinavian%20aesthetic%2C%20neutral%20warm%20tones%2C%20editorial%20product%20photography%20with%20gentle%20shadows%20and%20airy%20atmosphere%2C%20high%20end%20lifestyle%20brand%20look%2C%20soft%20focus%20background%20elements&width=1600&height=900&seq=hero-bg-yoybuy-01&orientation=landscape"
          alt="YOYBUY Beauty fashion products"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-white/20 to-white/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 flex flex-col items-center pt-20">
        <CategoryDropdown />

        <div className="mt-8 text-center">
          <h1 className="text-4xl md:text-[56px] font-heading font-bold text-foreground-950 leading-tight">
            YOYBUY Spreadsheet
          </h1>
          <p className="mt-3 text-2xl md:text-[44px] font-heading italic text-foreground-700">
            Умный шоппинг из Китая
          </p>
          <p className="mt-5 text-base md:text-lg text-foreground-500 font-light max-w-[520px] mx-auto leading-relaxed">
            Покупайте модную одежду, обувь и аксессуары из Китая проще, чем когда-либо. Ваш персональный spreadsheet-агент для безопасного шоппинга.
          </p>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-3 h-[52px] px-8 rounded-full bg-white border border-foreground-200/60 text-foreground-800 text-base font-medium hover:bg-accent-50 hover:border-accent-300 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            YOYBUY Sheet
            <span className="w-5 h-5 rounded-full bg-accent-500 flex items-center justify-center group-hover:bg-accent-600 transition-colors">
              <i className="ri-arrow-right-line text-white text-xs"></i>
            </span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-3 h-[52px] px-8 rounded-full bg-primary-500 text-white text-base font-medium hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Buy It Now
            <span className="w-5 h-5 rounded-full bg-white/20 flex items-center justify-center group-hover:bg-white/30 transition-colors">
              <i className="ri-arrow-right-line text-white text-xs"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}